import {
  formatOptionScore,
  type JobPdfDetails,
  nestedAddress,
  nestedChecked,
  nestedImages,
  nestedScalar,
  pdfPhotoStyle,
  plainOptionValue,
  styles,
} from '@features/buyer/jobs/single-job-detail/job-report/jobReportModel';
import { Checkbox } from '@mui/material';
import { Image, Page, Text, View } from '@react-pdf/renderer';
import i18n from '@translations/i18n';

// react-pdf renders outside React context, so use the i18n instance directly
const t = (key: string): string => String(i18n.t(key));

interface JobReportCriteriaProps {
  pdfData: JobPdfDetails;
}

export function JobReportCriteria({
  pdfData,
}: JobReportCriteriaProps): JSX.Element {
  return (
    <Page wrap>
      <View style={styles.topMarginView} fixed></View>
      <View>
        {pdfData?.ratingCriterias?.map((item) => (
          <View key={item.id}>
            <View style={styles.sectionHeadingBanner} wrap={false}>
              <Text>{item.title}</Text>
            </View>
            {item.options.length > 0 && (
              <View
                style={styles.ratingCriteriaOptionContainer}
                // wrap={false}
              >
                {item.options.length > 0 &&
                  item.options.map((option) => (
                    <View
                      style={styles.ratingCriteriaOptionMianContainer}
                      wrap={false}
                      key={option.id}
                    >
                      {option.type === 'Option' && (
                        <View>
                          <View
                            style={styles.ratingCriteriaOptionsTypeHeading}
                            // wrap={false}
                          >
                            <Text style={styles.ratingCriteriaOptionHeading}>
                              {option.ratingTitle}
                            </Text>
                          </View>
                          <View style={styles.ratingCriteriaOptionBox}>
                            <Text
                              style={{
                                fontSize: !option?.parentValue
                                  ? '18px'
                                  : '18px',
                                fontFamily: 'PoppinsSemi',
                                fontWeight: 'bold',
                              }}
                            >
                              {formatOptionScore(option)}
                            </Text>
                          </View>
                        </View>
                      )}
                      {option.type === 'DropDown' && (
                        <View>
                          <View
                            style={styles.ratingCriteriaOptionsTypeHeading}
                            // wrap={false}
                          >
                            <Text style={styles.ratingCriteriaOptionHeading}>
                              {option.ratingTitle}
                            </Text>
                          </View>
                          <View style={styles.ratingCriteriaOptionBox}>
                            <Text
                              style={{
                                fontSize: !option?.parentValue
                                  ? '17px'
                                  : '16px',
                              }}
                            >
                              {plainOptionValue(option)}
                            </Text>
                          </View>
                        </View>
                      )}
                      {(option.type === 'Number' ||
                        option.type === 'text' ||
                        option.type === 'Date' ||
                        option.type === 'Time') && (
                        <View style={styles.ratingCriteriaUpperBox}>
                          <View style={styles.reviewJobRowIdPoNumberInnerBox}>
                            <Text style={styles.ratingCriteriaOptionHeading}>
                              {option.ratingTitle}
                            </Text>
                            <Text style={styles.ratingCriteriaOptionValue}>
                              {nestedScalar(option)}
                            </Text>
                          </View>
                        </View>
                      )}
                      {option.type === 'Location' && (
                        <View style={styles.ratingCriteriaUpperBox}>
                          <View style={styles.reviewJobRowIdPoNumberInnerBox}>
                            <Text style={styles.ratingCriteriaOptionHeading}>
                              {option.ratingTitle}
                            </Text>
                            <Text style={styles.ratingCriteriaOptionValue}>
                              {nestedAddress(option)}
                            </Text>
                          </View>
                        </View>
                      )}
                      {option.type === 'Checkbox' && (
                        <View style={styles.ratingCriteriaUpperBox}>
                          <View style={styles.reviewJobRowIdPoNumberInnerBox}>
                            <Text style={styles.reviewJobSectionHeadingText}>
                              {nestedChecked(option) ? (
                                <View style={styles.reviewJobRightMarginView}>
                                  <Checkbox defaultChecked disabled />
                                </View>
                              ) : (
                                <View style={styles.reviewJobRightMarginView}>
                                  <Checkbox defaultChecked={false} disabled />
                                </View>
                              )}

                              <Text style={styles.ratingCriteriaOptionHeading}>
                                {' '}
                                {option.ratingTitle}
                              </Text>
                            </Text>
                          </View>
                        </View>
                      )}
                      {option.type === 'Image' && (
                        <>
                          <View>
                            <View
                              style={styles.ratingCriteriaOptionImageTitleBox}
                            >
                              <Text style={styles.ratingCriteriaOptionHeading}>
                                {option.ratingTitle}
                              </Text>
                            </View>
                          </View>
                          <View style={styles.sectionContainerImages}>
                            {nestedImages(option).length > 0 &&
                              nestedImages(option).map((img) => {
                                const photo = {
                                  alt: 'img',
                                  src: {
                                    uri: img.url ?? '',
                                    method: 'GET' as const,
                                    headers: {
                                      'Access-Control-Allow-Origin': '*',
                                      'Cache-Control': 'no-cache',
                                    },
                                    body: '',
                                  },
                                  style: pdfPhotoStyle(
                                    '5px solid black',
                                    '10px 10px 9px #F4AAB9'
                                  ),
                                };
                                return (
                                  <View
                                    style={styles.sectionInnerContainerImage}
                                    key={img.id}
                                  >
                                    <View
                                      style={{
                                        border: '2px solid black',
                                      }}
                                      wrap={false}
                                    >
                                      <Image {...photo} />
                                    </View>
                                  </View>
                                );
                              })}
                          </View>
                        </>
                      )}
                    </View>
                  ))}
              </View>
            )}

            <View style={styles.ratingCriteriaOptionHeadingBox} wrap={false}>
              <Text style={styles.ratingCriteriaOptionHeading}>{t('report.damages')}</Text>
            </View>
            <View style={styles.r8trCommentsContainer} wrap={false}>
              {item.damages.length > 0 ? (
                item.damages.map((item) => (
                  <Text key={item.id} style={styles.ratingCriteriaOptionValue}>
                    {item.title}{' '}
                  </Text>
                ))
              ) : (
                <>
                  <Text key={item.id} style={styles.ratingCriteriaOptionValue}>
                    {t('rating.noDamages')}
                  </Text>
                </>
              )}
            </View>
            <View style={styles.ratingCriteriaOptionHeadingBox} wrap={false}>
              <Text style={styles.ratingCriteriaOptionHeading}>
                {t('rating.r8trComments')}
              </Text>
            </View>
            <View style={styles.r8trCommentsContainer} wrap={false}>
              <Text style={styles.ratingCriteriaOptionValue}>
                {item.criteriaInfo
                  ? item.criteriaInfo
                  : ' no comments available'}
              </Text>
            </View>
            {(item.images?.length ?? 0) > 0 && (
              <>
                <View style={styles.ratingCriteriaOptionHeadingBox}>
                  <Text style={styles.ratingCriteriaOptionHeading}>
                    {t('rating.r8trPhotos')}
                  </Text>
                </View>
                <View style={styles.sectionContainerVideo}>
                  {(item.images ?? []).map(
                    (image) =>
                      image?.url && (
                        <View style={styles.sectionTableVideo} key={image.id}>
                          <View
                            style={{
                              border: '2px solid black',
                            }}
                            wrap={false}
                          >
                            <Image
                              // src={image?.url}
                              src={{
                                uri: image.url ?? '',
                                method: 'GET',
                                headers: {
                                  'Access-Control-Allow-Origin': '*',
                                  'Cache-Control': 'no-cache',
                                },
                                body: '',
                              }}
                              style={pdfPhotoStyle(
                                '10px solid black',
                                '10px 10px 9px black'
                              )}
                            />
                          </View>
                        </View>
                      )
                  )}
                </View>
              </>
            )}
            <View style={styles.topMarginView} fixed></View>
          </View>
        ))}
      </View>
      {/* <View style={styles.reviewJobBottomMarginView} fixed></View> */}
    </Page>
  );
}
